module.exports = __webpack_public_path__ + "static/media/fondo.56008cd0.png";